import React ,{ useState } from 'react'
import AddNewSocialHistory from './AddNewSocialHistory';

const SocialHistory = ({data, setIsRecordSaved,  patientID, ...props}) => {

    let { isViewAllowed, IsEditAllowed , IsDeleteAllowed} = props;
    const [isOpenSocialHistory, setIsOpenSocialHistory] = useState(false);
    const [socialHistoryData, setSocialHistoryData] = useState([]);
    const [expandItems, setExpandItems] = useState(true);
  
    const handleToggleExpand = () => {
      setExpandItems(prev => !prev);
    }
  
    const AddSocialHistory = (item) => {
      if(!isViewAllowed) return;
      setSocialHistoryData(item)
      setIsOpenSocialHistory(prev => !prev);
    }
    const CloseSocialHistory = () => {
      setIsOpenSocialHistory(false)
    }
  
    let PopupScreen = "";
    if (isOpenSocialHistory) {
        PopupScreen = <AddNewSocialHistory isOpenSocialHistory={isOpenSocialHistory} socialHistoryData={socialHistoryData} setIsRecordSaved={setIsRecordSaved} onClose={CloseSocialHistory}  patientID={patientID}// onDeleteSocialHistory={DeleteSocialHistory} 
        IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed}
        />
    }
  return (
    <div className='mb-2'>
        {PopupScreen}
        <div className="d-flex justify-content-between align-items-center mb-1 mx-2">
            <p className='cursor-pointer heading user-select-none' onClick={handleToggleExpand}>Social History</p>
            <div className={`ar-add-icon  ${isViewAllowed ? '' : 'disable'}`} onClick={() => AddSocialHistory({PatientHistoryID: null})}>
                <i className="icon-dash-plus"></i>
            </div>
        </div>
        <div className="d-flex flex-column gap-1 problem-scroll px-2">
        {expandItems &&
          (data?.length > 0 ?
        data.map(item => (
          <div className='ar-dot'>
            <p className={`multiline-ellipsis  text ar-hover-text validation_message ${isViewAllowed ? '' : 'disable'}`} onClick={() => AddSocialHistory(item)}>{item.Notes} </p>
        </div>))  :
        <p className="text C9-light-clr fst-italic">No social history recorded</p>)}
    </div>
    </div>
  )
}

export default SocialHistory